module.exports = __webpack_public_path__ + "static/5-3cbd7328c4650857bd18a424c190d3b8.png";